import type { EnnismoreTheme } from '@/ui/theme';

import { morgansOriginalsTheme } from './morgansoriginals.theme';

export const morgansOriginalsStMartinsLaneTheme: EnnismoreTheme = {
  ...morgansOriginalsTheme,
  logoUrl: '/brands/morgansoriginals/images/morgans-stmartinslane-logo.svg',
  componentProperties: {
    ...morgansOriginalsTheme.componentProperties,
    header: {
      ...morgansOriginalsTheme.componentProperties?.header,
      logo: {
        ...morgansOriginalsTheme.componentProperties?.header?.logo,
        padding: '0',
      },
    },
  },
};
